<template>
    <div>
        <section class="section section-shaped section-lg my-0">
            <div class="shape shape-style-1 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg-md container-title-content">
                <h3>Chính Sách Bảo Mật</h3>
            </div>
        </section>
        <section>
            <div class="row">
                <div class="container pt-lg-md">
                    <div class="row" style="margin-top: 30px;">
                        <div class="col-sm-4">
                            <ul id="navigation-help-list" class="navigation-help-list">
                                <li><router-link to="/dieu-khoan-dich-vu">Điều khoản dịch vụ</router-link></li>
                                <li><router-link to="/chinh-sach-bao-mat">Chính sách bảo mật</router-link></li>
                            </ul>
                        </div>
                        <div class="col-sm-8">
                            <div class="help-content-class">
                                <a name="chinh-sach-bao-mat" id="chinh-sach-bao-mat"></a>
                                <!-- <NapTien
                                        :items="trogiupjson"
                                /> -->
                                <ChinhSachBaoMat
                                        :items="chinhsachbaomat"
                                    />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ChinhSachBaoMat from "vue-faq-accordion";
// const trogiupjson = "../../../assets/data/tro-giup.json";
import chinhsachbaomat from "../../../assets/data/chinh-sach-bao-mat.json";
export default {
    name: "chinhsachbaomat",
        components: {
           ChinhSachBaoMat
    },
  data() {
    var data = chinhsachbaomat.map((item) => {
            return  {
                title: item.MessageTitle,
                value: item.MessageContent,
            }
    }
    );
        return { chinhsachbaomat: data };
  },
  methods: {
      parseJson: () =>{
          return chinhsachbaomat = JSON.parse(chinhsachbaomat);
      }
  },
  beforeMount(){
  }
};
</script>
<style scoped>
    .help-content-class section div.faq-wrapper div.accordion {
        margin-top: 0;
    }
    .help-content-class .accordion[data-v-36e025b4]{
        margin-top: 0!important
    }
    .navigation-help-list {
        padding:0;
    }
</style>